<template>
  <div>
    <router-view />
    <AnnouncementPopup v-if="showPopup" />
  </div>
</template>

<script>
import AnnouncementPopup from '@/components/AnnouncementPopup.vue';

export default {
  name: "App",
  components: {
    AnnouncementPopup,
  },

  computed: {
    showPopup() {
      const path = this.$route?.path || '';
      return !path.startsWith('/website-cp') && !path.startsWith('/portal');
    },
  },
};
</script>

<style>
*{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
  font-variation-settings:
    "wdth" 100;
}
body{
  margin: 0;
  padding: 0;
}
</style>
